import(/* webpackMode: "eager" */ "/vercel/path0/src/app/faqs/layout.js");
